<template>
  <div id="reject-modal-template">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper reject-modal">
          <div class="modal-container md-modal-container">
            <div class="modal-body">
              <h2 class="show-title">반려</h2>
              <!-- form class="form-horizontal" -->
              <table class="table table-bordered text-center table-system-authority-roles"><caption>커뮤니티 반려 대상 정보</caption>
                <tr><td>&nbsp;</td></tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style="text-align: left;" width="90%">
                  <div class="form-group">
                    <label>반려대상 : </label>
                    <span class="reciever-tag" v-for="list in nameList">{{list}}&nbsp;&nbsp;</span>
                  </div>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style="text-align: left;" width="90%">
                    <div class="form-group">
                      <label>반려내용 : </label>
                    </div>
                  </td>
                <tr>
                  <td style="width:100%; height:200px;">
                    <textarea class="form-control" v-model="reason" rows="2" style="width:98%; height:98%;" title="결과 입력"></textarea>
                    <input type="hidden" class="form-control" name="reject"/>
                    <input type="hidden" class="form-control" name="memId"/>
                  </td>
                </tr>
              </table>
              <!-- /form -->
              <div class="attendance-action">
                <button class="sm-btn btn--blue-line" @click="save">저장</button>
                <button class="sm-btn btn--blue-line" @click="close">닫기</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import Axios from 'axios';

  export default {
    name: 'reject-modal-template',
    props: ['communityId', 'memberId', 'memberNm'],
    data() {
      return {
        showModal: false,
        communityIdStr: null,
        memberIdStr: null,
        memberNmStr: null,
        nameList: [],
        reason: '',
        urlHome: `/mypage-community-member-detail.do?id=${this.communityId}`,
        memId: null,
      };
    },
    computed: {
    },
    methods: {
      setButtons() {
      },
      save() {
        const parameters = {
          id: this.communityIdStr,
          GUBUN: 'reject',
          reason: this.reason,
          memId: this.memId,
        };
        const result = window.confirm('반려처리 하시겠습니까?');
        if (result) {
          if (this.reason.length > 30) {
            alert('반려사유를 30자 이내로 변경합니다.');
            this.reason = this.reason.slice(0, 30);
          }
          if (this.reason.length < 1) {
            alert('반려사유를 입력해 주세요.');
            return;
          }
          Axios.post(this.urlHome, parameters, { params: { GUBUN: 'reject', reason: this.reason, memId: this.memId } }).then(() => {
            alert('반려처리 되었습니다.');
            this.close();
          }).catch((error) => {
            this.errorMessage = error.response.data.msg;
          });
        }
      },
      close() {
        this.showModal = false;
        document.getElementsByTagName('body')[0].classList.remove('modal-open');
        location.reload();
      },
      getMemberNm() {
        let tmpNameList = null;
        if (this.memberNmStr && this.memberNmStr.replace(/ /gi, '').length !== 0) {
          tmpNameList = this.memberNmStr.replace(/#/gi, ',');
          tmpNameList = tmpNameList.split(',');
          for (let i = 0; i < tmpNameList.length - 1; i += 1) {
            this.nameList.push(tmpNameList[i]);
          }
        }
        return this.nameList;
      },
    },
    mounted() {
      this.communityIdStr = this.communityId;
      this.memberIdStr = this.memberId;
      this.memberNmStr = this.memberNm;
      $('input[name=reject]').val('reject');
      $('input[name=memId]').val(this.memberIdStr);
      this.memId = $('input[name=memId]').val();
      this.getMemberNm();
      $('body').addClass('modal-open');
      this.showModal = true;
    },
    created() {
    },
  };
</script>


// WEBPACK FOOTER //
// MemberRejectButton.vue?d67dd452